(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[94],{

/***/ 2767:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[...slug]",
      function () {
        return __webpack_require__(200);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/next-superjson-plugin@0.4.9_o7ninycgoz2lf73je52p7wq4ja/node_modules/next-superjson-plugin/tools.js
var tools = __webpack_require__(2430);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(7458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-mdx-remote@3.0.8_biqbaboplfbrettd7655fr4n2y/node_modules/next-mdx-remote/dist/index.js
var dist = __webpack_require__(7424);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(2983);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/layout/site-layout.tsx + 2 modules
var site_layout = __webpack_require__(6421);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/mdx-components/mdx-components.tsx
var mdx_components = __webpack_require__(5762);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/comment-widget/comment-widget.tsx
var comment_widget = __webpack_require__(5616);
// EXTERNAL MODULE: ../../packages/ui/src/components/image/image.tsx
var image_image = __webpack_require__(6100);
// EXTERNAL MODULE: ../../packages/ui/src/hooks/use-has-mounted.ts
var use_has_mounted = __webpack_require__(1492);
// EXTERNAL MODULE: ../../packages/ui/src/utilities/image.ts
var utilities_image = __webpack_require__(4299);
;// CONCATENATED MODULE: ../../packages/ui/src/pages/blog/post.tsx







function BlogPost(param) {
    let { mdxSource , frontMatter  } = param;
    const hasMounted = (0,use_has_mounted/* useHasMounted */.f)();
    const banner = react.useMemo(()=>{
        if ((frontMatter === null || frontMatter === void 0 ? void 0 : frontMatter.banner) && hasMounted) {
            return (0,utilities_image/* getBannerProps */.U)(frontMatter.banner);
        }
    }, [
        frontMatter === null || frontMatter === void 0 ? void 0 : frontMatter.banner,
        hasMounted
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(site_layout/* default */.Z, {
        title: (frontMatter === null || frontMatter === void 0 ? void 0 : frontMatter.title) || "Blog",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "flex flex-row space-x-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                    className: "prose flex-1 overflow-y-auto",
                    children: [
                        banner && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pb-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_image/* Image */.E, {
                                ...banner,
                                layout: "responsive",
                                alt: "banner"
                            })
                        }),
                        mdxSource && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* MDXRemote */.R, {
                            ...mdxSource,
                            components: mdx_components/* MDXComponents */.t
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comment_widget/* CommentWidget */._, {})
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/blog/[...slug].tsx


var __N_SSG = true;
/* harmony default export */ var _slug_ = ((0,tools.withSuperJSONPage)(BlogPost));


/***/ }),

/***/ 5616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ CommentWidget; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var _chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1096);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3765);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4442);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2983);
/* harmony import */ var _components_client_only__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5184);






function CommentWidget() {
    const { resolvedTheme  } = (0,next_themes__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .F)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_client_only__WEBPACK_IMPORTED_MODULE_4__/* .ClientOnly */ .q, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                "data-chirpy-comment": true,
                "data-chirpy-theme": resolvedTheme || "system",
                className: "my-16"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: "/bootstrap/comment.js",
                strategy: "afterInteractive",
                "data-chirpy-domain": new URL((0,_chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_5__/* .getAppURL */ .dj)()).hostname
            })
        ]
    });
}


/***/ }),

/***/ 5762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ MDXComponents; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4517);
/* harmony import */ var _components_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3308);
/* harmony import */ var _mdx_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3523);
/* harmony import */ var _mdx_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_mdx_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const MDXComponents = {
    a: MDXLink,
    pre: Pre
};
function MDXLink(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_link__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .r, {
        href: props.href || "",
        variant: "primary",
        children: props.children
    });
}
function Pre(param) {
    let { children , className , ...restProps } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pre", {
        ...restProps,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("not-prose whitespace-normal break-all md:whitespace-pre md:break-words", (_mdx_module_scss__WEBPACK_IMPORTED_MODULE_3___default().blockPre), className),
        children: children
    });
}


/***/ }),

/***/ 6100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8293);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2983);



function Image(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        ...props
    });
}


/***/ }),

/***/ 4299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getBannerProps; }
/* harmony export */ });
/* harmony import */ var _chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1096);

function getBannerProps(banner) {
    if (_chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_0__/* .isSSRMode */ .kp || !banner) {
        return null;
    }
    const url = new URL(banner, window.location.origin);
    const width = Number.parseInt(url.searchParams.get("width") || "0", 10);
    const height = Number.parseInt(url.searchParams.get("height") || "0", 10);
    return {
        src: url.pathname,
        width,
        height
    };
}


/***/ }),

/***/ 3523:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blockPre":"mdx_blockPre__qYcGw"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [66,426,505,293,23,421,774,888,179], function() { return __webpack_exec__(2767); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);